
import data from '../../data.json';
// console.log(data.products)
const intiState = {
    products:data.products,
    newProducts:data.newProducts,
    dealDay:data.dealDay,
    newProduct:{}
}

export const productsReducer = (state = intiState, action) => {
    switch(action.type){
        case "DETAILS":
            
            return{
                ...state,
                newProduct:state.newProducts.find(item => item.id === parseInt(action.id))
            }
            default :
            return state;
        }
    }
 

